{
  "app": {
    "title": "Sculpt Agent",
    "loading": "Chargement…",
    "notExcel": "Ouvrez ce complément dans Excel Desktop pour discuter avec Sculpt Agent.",
    "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter.",
    "selfTestMissing": "Le harnais d'auto-test n'est pas présent dans cette version.",
    "byline": "par Peerception"
  },
  "login": {
    "title": "Connexion",
    "subtitle": "Utilisez votre compte Sculpt Agent pour discuter de ce classeur avec l'assistant.",
    "email": "E-mail",
    "emailPlaceholder": "vous@exemple.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "Saisissez votre mot de passe",
    "show": "afficher",
    "hide": "masquer",
    "continue": "Se connecter",
    "submitting": "Connexion…",
    "error": "E-mail ou mot de passe invalide.",
    "rateLimited": "Trop de tentatives de connexion. Attendez 15 minutes, ou continuez avec Microsoft.",
    "microsoft": "Continuer avec Microsoft",
    "microsoftBusy": "En attente de Microsoft…",
    "or": "ou",
    "sso": {
      "cancelled": "Connexion annulée.",
      "signup_disabled": "Votre compte Microsoft n’est pas encore enregistré sur Sculpt Agent. Demandez une invitation à votre administrateur.",
      "sso_failed": "La connexion Microsoft a échoué. Réessayez.",
      "origin_not_allowed": "Cette origine du complément n’est pas autorisée pour la connexion Microsoft (réglage API SCULPT_OAUTH_ORIGINS).",
      "unsupported": "La connexion Microsoft nécessite la boîte de dialogue Office, absente de cette version d’Excel. Utilisez votre e-mail et votre mot de passe.",
      "timeout": "La connexion Microsoft a expiré.",
      "dialog_error": "La fenêtre de connexion n’a pas pu s’ouvrir.",
      "bad_message": "Réponse inattendue de la fenêtre de connexion.",
      "account_disabled": "Ce compte est désactivé. Contactez l’équipe Sculpt Agent.",
      "email_plus_address": "Ce compte Microsoft utilise une adresse avec une partie « +… », qui ne peut pas ouvrir de compte Sculpt Agent. Connectez-vous avec votre propre adresse.",
      "email_disposable_domain": "Ce compte Microsoft utilise une adresse e-mail jetable ou temporaire, qui ne peut pas ouvrir de compte Sculpt Agent. Connectez-vous avec votre propre adresse."
    },
    "success": "Connecté. Ouverture de l’assistant…",
    "noAccount": "Pas encore de compte ?",
    "createAccount": "Créer un compte",
    "forgot": "Mot de passe oublié ?",
    "signupBusy": "En attente de l’inscription…"
  },
  "legal": {
    "mention": "En continuant, vous acceptez les <terms>Conditions générales de vente</terms>, dont l'<dpa>Accord de traitement des données</dpa>. Voir notre <privacy>Politique de confidentialité</privacy>."
  },
  "header": {
    "history": "Historique",
    "newChat": "Nouvelle discussion",
    "logout": "Se déconnecter",
    "language": "Langue",
    "protect": "Feuilles protégées…",
    "converge": "Converger les blocs circulaires",
    "report": "Signaler cette conversation"
  },
  "mode": {
    "label": "Mode",
    "plan": "Plan",
    "ask": "Demander",
    "auto": "Auto",
    "full_auto": "Auto total",
    "planHint": "Lecture seule : l'assistant propose des modifications sans écrire.",
    "askHint": "Chaque écriture attend votre approbation avant d'être exécutée.",
    "autoHint": "Les écritures s'exécutent automatiquement ; les actions destructives demandent confirmation.",
    "full_autoHint": "Tout s'exécute sans confirmation. À utiliser avec précaution."
  },
  "welcome": {
    "greeting": "Bienvenue, {{name}}",
    "greetingAnon": "Bienvenue"
  },
  "chat": {
    "errorGeneric": "Une erreur est survenue. Veuillez réessayer.",
    "streamError": "L'assistant a été interrompu.",
    "thinking": "Réflexion…",
    "workingExcel": "Travail dans Excel…",
    "readingModel": "Lecture du modèle…",
    "planning": "Préparation de la modification…",
    "writingProgress": "Écriture dans Excel · {{done}} sur {{total}}",
    "writingProgressSheet": "Écriture dans Excel · {{done}} sur {{total}} · {{sheet}}",
    "checkingWorkbook": "Vérification du classeur…",
    "updatingIndex": "Lecture de vos modifications…",
    "indexFailed": "Le classeur n'a pas pu être lu ({{error}}). Renvoyez votre message.",
    "awaitingUnderstanding": "Analyse de vos modifications…",
    "indexNotUnderstood": "Sculpt n'a pas fini d'analyser vos modifications. Renvoyez votre message dans un instant.",
    "turnsInProgress": "Vous avez déjà {{limit}} réponses en cours dans d'autres classeurs. Attendez qu'une se termine, puis renvoyez votre message.",
    "serviceInterrupted": "L'assistant est momentanément indisponible. Notre équipe s'en occupe : merci de réessayer un peu plus tard.",
    "selectInExcel": "Sélectionner {{address}} dans Excel",
    "copyCode": "Copier",
    "copied": "Copié"
  },
  "composer": {
    "disclaimer": "Sculpt est une IA et peut se tromper. Vérifiez ses modifications.",
    "answering": "Répondez ici, ou utilisez la carte ci-dessus",
    "placeholder": "Demandez ce que vous voulez…",
    "hint": "Entrée ↵ · Maj+Entrée saut de ligne",
    "working": "En cours…",
    "send": "Envoyer",
    "stop": "Arrêter",
    "spendTitle": "Consommation IA sur la période : dépensé / inclus",
    "trialOffer": "{{offer}} (essai)",
    "trialEnds": "fin de l'essai le {{date}}",
    "renews": "renouvellement le {{date}}",
    "credits": "{{amount}} de crédits",
    "creditsLeft": "Crédits · {{amount}} restants",
    "usageLoading": "Consommation IA · …",
    "chooseOffer": "Choisir une offre",
    "usage": "Consommation",
    "freeTier": "Offre gratuite",
    "orgPool": "organisation {{spent}} / {{budget}}",
    "yourShare": "votre part {{spent}} / {{cap}}",
    "openBilling": "Acheter des crédits ou changer d'offre",
    "limit": {
      "legacy": "Limite d'utilisation atteinte. Contactez Peerception pour étendre votre forfait.",
      "limit_reached": "L'usage inclus et les crédits de votre organisation sont épuisés. Un administrateur peut acheter des crédits ou changer d'offre.",
      "user_cap_reached": "Vous avez consommé votre part de l'usage inclus ({{cap}}). Des crédits ou une offre supérieure la lèvent.",
      "member_cap_reached": "Vous avez atteint la limite fixée par votre administrateur ({{cap}}).",
      "no_subscription": "Votre organisation n'a pas d'abonnement actif.",
      "free_full": "Votre organisation n'a pas encore d'abonnement. Un administrateur peut choisir une offre.",
      "trial_ended": "Votre essai est terminé. Un administrateur peut choisir une offre pour continuer.",
      "payment_overdue": "Le renouvellement de votre organisation est impayé."
    },
    "upgrade": "Changer d'offre"
  },
  "skills": {
    "menu": "Skills — des recettes pour une tâche complète",
    "button": "Utiliser un skill (/)"
  },
  "attachments": {
    "attach": "Joindre un fichier (PDF, Word, PowerPoint, Excel, CSV, texte, image)",
    "placeholder": "Posez une question sur le fichier joint…",
    "uploading": "Envoi en cours…",
    "remove": "Retirer {{name}}",
    "pages_one": "{{count}} page",
    "pages_other": "{{count}} pages",
    "noText": "aucun texte lisible",
    "truncated": "long : lu page par page",
    "errors": {
      "type": "Type de fichier non pris en charge — PDF, Word (.docx), PowerPoint (.pptx), Excel, CSV, texte ou image.",
      "size": "Fichier trop volumineux (20 Mo max).",
      "count": "5 fichiers par message au maximum.",
      "upload": "Échec de l'envoi.",
      "ocr": "Impossible de transcrire les pages scannées."
    },
    "reading": "Lecture des pages scannées…",
    "ocr_one": "{{count}} page transcrite",
    "ocr_other": "{{count}} pages transcrites"
  },
  "context": {
    "selectionHint": "La sélection est envoyée avec vos prochains messages pour désigner « cette cellule / ici ». L’assistant peut toujours lire et modifier n’importe quelle feuille.",
    "addSelection": "Ajouter la sélection actuelle au contexte",
    "removeSelection": "Retirer la sélection du contexte"
  },
  "approval": {
    "title_one": "1 modification à appliquer",
    "title_other": "{{count}} modifications à appliquer",
    "show": "Voir le détail",
    "hide": "Masquer le détail",
    "accept": "Accepter les modifications",
    "reject": "Refuser",
    "reasonPlaceholder": "Que faut-il changer ? (facultatif)",
    "confirmReject": "Refuser les modifications",
    "back": "Retour",
    "accepted_one": "Acceptée · 1 modification",
    "accepted_other": "Acceptées · {{count}} modifications",
    "failed_one": "1 en échec",
    "failed_other": "{{count}} en échec",
    "rejected": "Refusé. Rien n'a changé."
  },
  "action": {
    "apply": "Appliquer à la feuille",
    "discard": "Ignorer",
    "applyAll": "Tout appliquer",
    "discardAll": "Tout ignorer",
    "applying": "Application…",
    "applied": "Appliqué",
    "undo": "Annuler",
    "reverted": "↺ Rétabli. Le contenu précédent est de retour.",
    "discarded": "Ignoré. Rien n'a changé.",
    "failed": "Échec",
    "show": "Afficher dans Excel",
    "destructiveWarning": "Cette action ne peut pas être annulée par l'assistant.",
    "cells_one": "{{count}} cellule",
    "cells_other": "{{count}} cellules",
    "oneSheet": "1 feuille",
    "oneChart": "1 graphique",
    "oneTable": "1 tableau",
    "oneName": "1 nom",
    "done": "terminé",
    "overwriteAck": "Écraser {{count}} cellules non vides ({{sample}})",
    "protectedSheet": "Feuille protégée — cette écriture est toujours confirmée.",
    "converged": "convergé",
    "newModel": "nouveau modèle"
  },
  "question": {
    "title": "Sculpt a besoin de savoir",
    "send": "Envoyer les réponses",
    "other": "Autre…",
    "otherPlaceholder": "Votre réponse",
    "answerPlaceholder": "Votre réponse",
    "suggested": "Recommandé",
    "leftToSculpt": "laissé à Sculpt",
    "cancel": "Annuler",
    "cancelled": "Annulé — rien n'a été fait."
  },
  "batch": {
    "writing_one": "Écriture d'1 modification",
    "writing_other": "Écriture de {{count}} modifications · {{sheets}} feuilles",
    "reading_one": "Lecture d'1 emplacement",
    "reading_other": "Lecture de {{count}} emplacements · {{sheets}} feuilles",
    "doneWriting_one": "1 modification écrite",
    "doneWriting_other": "{{count}} modifications sur {{sheets}} feuilles",
    "doneReading_one": "1 emplacement lu",
    "doneReading_other": "{{count}} emplacements sur {{sheets}} feuilles",
    "progress": "{{done}} / {{total}}",
    "calls_one": "1",
    "calls_other": "{{count}}",
    "collapse": "Réduire"
  },
  "plan": {
    "add": "Ajout de « {{name}} »",
    "edit": "Modification de « {{name}} »",
    "delete": "Suppression de « {{name}} »",
    "modelledOn": "sur le modèle de {{name}}",
    "asked": "Vous avez demandé « {{asked}} » : aucun objet ne porte ce nom, le plan porte donc sur « {{name}} », le plus proche.",
    "consumers": "Formules modifiées avec lui",
    "rewritten": "réécrite",
    "widened": "Excel élargit sa plage",
    "where": "Où",
    "rows_one": "1 ligne en {{at}}",
    "rows_other": "{{count}} lignes en {{at}}",
    "cols_one": "1 colonne en {{at}}",
    "cols_other": "{{count}} colonnes en {{at}}",
    "rowsBand_one": "ligne {{first}}",
    "rowsBand_other": "lignes {{first}}–{{last}}",
    "colsBand_one": "colonne {{first}}",
    "colsBand_other": "colonnes {{first}}–{{last}}",
    "notExtended": "Non étendues",
    "notExtendedHint": "Y ajouter un terme calculerait sans rien vouloir dire — à vous d'en juger.",
    "byHand": "Mentionne encore « {{name}} » — à retirer à la main",
    "proposed": "Proposition : rien n’a été écrit. Passez en mode Demander ou Auto pour l’appliquer.",
    "showFormula": "Afficher la formule"
  },
  "history": {
    "title": "Historique",
    "back": "Retour à la discussion",
    "search": "Rechercher une discussion",
    "opening": "Ouverture de la discussion",
    "empty": "Aucune conversation pour ce classeur.",
    "noMatch": "Aucune discussion ne correspond à votre recherche.",
    "untitled": "Conversation sans titre",
    "delete": "Supprimer",
    "deleteConfirm": "Supprimer cette conversation ?",
    "rename": "Renommer",
    "renamePrompt": "Nouveau titre",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "confirmDelete": "Supprimer",
    "actionFailed": "L'action a échoué. Réessayez.",
    "groups": {
      "today": "Aujourd'hui",
      "yesterday": "Hier",
      "lastWeek": "Semaine dernière",
      "earlier": "Plus ancien"
    },
    "thisWorkbook": "Ce classeur",
    "all": "Toutes mes conversations",
    "ancestor": "Version précédente · {{name}}",
    "readOnly": "lecture seule",
    "noWorkbook": "aucun classeur",
    "emptyAll": "Aucune conversation pour l’instant.",
    "resumed": "reprise"
  },
  "agents": {
    "main": "principal",
    "discovery": "exploration",
    "builder": "construction",
    "formatting": "mise en forme",
    "charts": "graphiques",
    "verifier": "vérification"
  },
  "discovery": {
    "title": "Comment nous avez-vous connus ?",
    "subtitle": "Cette question est facultative. Votre réponse nous aide à savoir où faire connaître Sculpt.",
    "continue": "Continuer",
    "skip": "Passer",
    "sources": {
      "linkedin": "LinkedIn",
      "google": "Google",
      "youtube": "YouTube",
      "word_of_mouth": "Bouche à oreille",
      "other": "Autre"
    }
  },
  "access": {
    "title": "Sculpt Agent n’est pas encore activé pour votre compte.",
    "message": "Demandez à votre contact Peerception d’activer l’assistant pour vous, puis vérifiez à nouveau.",
    "signedInAs": "Connecté en tant que",
    "checkAgain": "Vérifier à nouveau",
    "checking": "Vérification…",
    "stillDenied": "Toujours pas activé. L’accès est accordé par Peerception ; rien à faire de votre côté.",
    "signOut": "Se déconnecter",
    "reasons": {
      "email_unverified": {
        "title": "Confirmez votre adresse e-mail pour commencer.",
        "message": "Nous vous avons envoyé un lien à l’inscription. Ouvrez-le, puis vérifiez à nouveau ici.",
        "stillDenied": "Toujours pas confirmé. Ouvrez le lien de l’e-mail, ou demandez-en un nouveau ci-dessous."
      },
      "organization_suspended": {
        "title": "L’accès de votre organisation est suspendu.",
        "message": "Demandez à votre contact Peerception de le rétablir, puis vérifiez à nouveau.",
        "stillDenied": "Toujours suspendu. L’accès est rétabli par Peerception ; rien à faire de votre côté."
      },
      "no_organization": {
        "title": "Votre compte n’a pas encore d’organisation.",
        "message": "Demandez à votre contact Peerception, puis vérifiez à nouveau.",
        "stillDenied": "Toujours pas d’organisation. Peerception s’en charge ; rien à faire de votre côté."
      },
      "no_subscription": {
        "title": "Votre organisation n’a pas d’abonnement.",
        "message": "Un propriétaire ou administrateur de votre organisation choisit une offre dans votre compte, puis vérifiez à nouveau ici.",
        "stillDenied": "Toujours pas d’abonnement. Il démarre dès que sa commande est payée."
      },
      "free_full": {
        "title": "Toutes les places de l’offre Free sont prises pour le moment.",
        "message": "Choisissez une offre payante dans votre compte, ou inscrivez-vous sur la liste d’attente, puis vérifiez à nouveau ici.",
        "stillDenied": "Toujours pas d’abonnement. Une offre payante démarre dès que sa commande est payée ; une place Free, dès qu’elle se libère."
      },
      "trial_ended": {
        "title": "Votre essai est terminé.",
        "message": "Choisissez une offre dans votre compte pour continuer à utiliser Sculpt. Vos classeurs et conversations sont conservés.",
        "stillDenied": "Toujours pas d’offre active. Elle démarre dès que sa commande est payée."
      },
      "payment_overdue": {
        "title": "Le renouvellement de votre abonnement est impayé.",
        "message": "L’assistant est en pause jusqu’au paiement. Les modalités de paiement sont dans votre compte.",
        "stillDenied": "Toujours impayé. L’accès revient dès que le paiement est enregistré."
      }
    },
    "resend": "Renvoyer l’e-mail",
    "resending": "Envoi…",
    "resent": "Envoyé. Vérifiez votre boîte de réception (et les indésirables).",
    "resendFailed": "L’e-mail n’a pas pu être envoyé. Réessayez dans une minute.",
    "openPortal": "Ouvrir mon compte",
    "openBilling": "Ouvrir l’abonnement dans mon compte"
  },
  "protect": {
    "title": "Feuilles protégées",
    "help": "L’agent n’écrit jamais dans une feuille cochée sans demander, quel que soit le mode.",
    "noWorkbook": "Envoyez un premier message pour que ce classeur reçoive une identité.",
    "save": "Enregistrer",
    "cancel": "Annuler"
  },
  "converge": {
    "none": "Aucun bloc circulaire dans la mémoire de ce classeur.",
    "running": "Convergence…",
    "converged": "{{block}} : convergé en {{count}} itérations.",
    "diverged": "{{block}} : divergence — valeurs collées restaurées.",
    "capped": "{{block}} : non convergé après {{count}} itérations.",
    "failed": "{{block}} : {{error}}",
    "iterativeOn": "Le calcul itératif d’Excel est activé — désactivez-le (Fichier → Options → Formules).",
    "dismiss": "Fermer"
  },
  "feedback": {
    "question": "Comment ça se passe ?",
    "up": "Utile",
    "down": "Pas utile",
    "whatWrong": "Qu'est-ce qui n'a pas marché ?",
    "whatWorked": "Qu'est-ce qui a bien marché ?",
    "commentPlaceholder": "Autre chose ? (facultatif)",
    "comment": "Ajouter un commentaire",
    "editComment": "Modifier votre commentaire",
    "remove": "Retirer la note",
    "pickLabel": "Choisissez une étiquette pour envoyer.",
    "back": "Retour",
    "send": "Envoyer",
    "cancel": "Annuler",
    "dismiss": "Fermer",
    "thanks": "Merci, c'est noté.",
    "failed": "Impossible d'envoyer votre retour.",
    "tag": {
      "wrong_formula": "Formule incorrecte",
      "misunderstood": "M'a mal compris",
      "too_slow": "Trop lent",
      "broke_sheet": "A cassé ma feuille",
      "wrong_output": "Résultat faux",
      "too_many_steps": "Trop d'étapes",
      "accurate": "Juste",
      "understood": "M'a bien compris",
      "fast": "Rapide",
      "saved_time": "M'a fait gagner du temps",
      "other": "Autre chose"
    }
  },
  "report": {
    "title": "Signaler cette conversation",
    "intro": "Une personne de l'équipe Sculpt lira cette conversation pour l'examiner.",
    "reason": "Pourquoi la signalez-vous ?",
    "reasons": {
      "wrong_result": "Chiffres ou formules faux",
      "damaged_workbook": "A abîmé mon classeur",
      "inappropriate": "Réponse inappropriée",
      "data_concern": "Inquiétude sur mes données ou la sécurité",
      "other": "Autre chose"
    },
    "commentPlaceholder": "Que s'est-il passé ? (facultatif)",
    "cancel": "Annuler",
    "send": "Envoyer le signalement",
    "sending": "Envoi…",
    "close": "Fermer",
    "sent": "Signalement envoyé : notre équipe va l'examiner.",
    "failed": "Impossible d'envoyer le signalement. Réessayez.",
    "tooMany": "Vous avez envoyé beaucoup de signalements aujourd'hui. Réessayez demain."
  },
  "index": {
    "failed": "Échec de l’indexation : {{error}}",
    "composerLocked": "Indexation du classeur… la conversation s’ouvre quand l’index est prêt.",
    "composerFailed": "Le classeur n’a pas pu être indexé. Réessayez pour relancer.",
    "composerUnderstanding": "Analyse du classeur… la conversation s’ouvre quand les feuilles sont analysées.",
    "reading": "Lecture du classeur…",
    "understandingRun": "Analyse du classeur…",
    "updating": "Prise en compte de vos modifications…",
    "understandLater": "Le classeur sera relu à votre prochain message.",
    "retry": "Réessayer",
    "reread": "Relire le classeur",
    "dot": {
      "ready": "Classeur à jour",
      "busy": "Mise à jour du classeur…",
      "warn": "Le classeur sera relu à votre prochain message",
      "failed": "Le classeur n’a pas pu être indexé"
    }
  },
  "intro": {
    "title": "Laissez Sculpt lire votre modèle",
    "why": "Sculpt lit une fois l'ensemble du classeur et en construit une carte — les feuilles, l'enchaînement des calculs. C'est cette carte qui lui permet de répondre sur votre modèle et de placer une modification au bon endroit, plutôt que de deviner cellule par cellule.",
    "pointUpload": "Vos feuilles sont envoyées à Sculpt Agent pour construire la carte.",
    "pointOnce": "Cela n'a lieu qu'une fois par fichier. Les sessions suivantes ouvrent directement la conversation, et seules vos modifications sont relues.",
    "timeUnder1": "Ce classeur devrait prendre moins d'une minute.",
    "timeAbout1": "Ce classeur devrait prendre environ une minute.",
    "timeRange": "Ce classeur devrait prendre de {{low}} à {{high}} minutes.",
    "sheets_one": "1 feuille",
    "sheets_other": "{{count}} feuilles",
    "modelTitle": "Choisissez le modèle",
    "modelWhy": "Il détermine où votre classeur est envoyé pour être lu, et vos conversations l'utilisent. Vous pourrez en changer ensuite dans la conversation.",
    "start": "Lire mon classeur",
    "demoLead": "Vous pouvez aussi découvrir Sculpt sur",
    "demoLink": "notre modèle de démonstration →",
    "looking": "Examen de votre classeur…",
    "cellEdit": "Excel est occupé pendant l’édition d’une cellule. Appuyez sur Entrée ou Échap pour la terminer, et Sculpt s’ouvre juste après.",
    "retry": "Réessayer",
    "starting": "Démarrage…",
    "progress": "{{done}} sur {{total}}",
    "patience": "Excel peut être ralenti pendant l'opération, mieux vaut éviter les manipulations lourdes dans le classeur. La conversation s'ouvre dès que c'est terminé.",
    "phase": {
      "probing": "Examen de votre classeur…",
      "cell_edit": "En attente de la fin de l’édition de la cellule",
      "capturing": "Lecture de vos feuilles",
      "committing": "Construction de la carte",
      "understanding": "Compréhension de votre modèle",
      "idle": "Démarrage…",
      "ready": "Prêt",
      "needs_consent": "Prêt quand vous voulez",
      "failed": "Échec de l'indexation"
    }
  },
  "identity": {
    "title": "De quel classeur s’agit-il ?",
    "titleShared": "Ce fichier a d’abord été lu par quelqu’un d’autre",
    "changed": {
      "name": "La dernière fois, ce fichier s’appelait « {{name}} ». Il a été renommé.",
      "place": "C’est « {{name}} », ouvert depuis un autre emplacement.",
      "both": "La dernière fois, ce fichier était « {{name}} ». Il a été renommé et se trouve à un autre emplacement."
    },
    "whyShared": "« {{name}} » a d’abord été lu par un autre utilisateur. Travaillez-vous sur son fichier ou sur votre propre copie ?",
    "same": "Même fichier",
    "sameHint": "Il a été déplacé ou renommé. Ses conversations continuent ici.",
    "fork": "Nouvelle version de « {{name}} »",
    "forkHint": "Ce fichier va diverger de l’original. Il gardera l’historique des conversations associées à l’original.",
    "other": "Un autre classeur",
    "otherHint": "Rien n’est repris : Sculpt le lit depuis le début.",
    "resume": "Reprendre « {{name}} »",
    "resumeHint": "Nouvelle version de « {{parent}} », créée le {{date}}.",
    "shared": "Partagé avec moi",
    "sharedHint": "Le même fichier que celui de son propriétaire. Rien n’y est écrit.",
    "ownCopy": "Ma propre copie",
    "ownCopyHint": "Un classeur à vous, lu depuis le début.",
    "ownCopyVersion": "Ma propre copie — nouvelle version",
    "ownCopyOther": "Ma propre copie — un autre classeur",
    "lostId": "« {{name}} » a déjà été lu à cet emplacement, mais les feuilles de ce fichier ne sont pas les mêmes.",
    "lostIdResumeHint": "C’est bien « {{name}} » : ses conversations continuent ici, et chaque feuille est relue.",
    "dismiss": "Pas maintenant : le traiter comme le même fichier pour cette session",
    "dismissLostId": "Pas maintenant : le lire comme un nouveau classeur pour cette session",
    "failed": "La réponse n’a pas pu être enregistrée : {{error}}"
  },
  "thread": {
    "readOnly": "Cette conversation appartient à « {{name}} ». Elle est en lecture seule dans ce classeur.",
    "readOnlyNoFile": "Cette conversation n’est liée à aucun classeur. Elle est en lecture seule ici.",
    "continueHere": "Continuer dans une nouvelle conversation",
    "continuing": "Résumé de la conversation…",
    "continueFailed": "La conversation n’a pas pu être continuée : {{error}}",
    "resumedFrom": "Reprise de « {{title}} » · {{file}}",
    "composerReadOnly": "Lecture seule dans ce classeur : continuez dans une nouvelle conversation pour écrire."
  },
  "account": {
    "menu": "Compte",
    "usage": "Offre et consommation",
    "billing": "Facturation",
    "invoices": "Factures",
    "organization": "Organisation",
    "profile": "Profil"
  },
  "model": {
    "label": "Modèle",
    "hint": "{{model}}, hébergé par {{host}}",
    "hostedBy": "hébergé par {{host}}",
    "dataIn": "données en",
    "price1": "Prix bas",
    "price2": "Prix élevé",
    "madeBy": "modèle de {{maker}}",
    "startsNew": "Une conversation garde son modèle. En choisir un autre démarre une nouvelle conversation.",
    "refused": "Votre organisation n'autorise plus le modèle de cette conversation. Démarrez une nouvelle conversation pour continuer."
  },
  "flag": {
    "US": "États-Unis",
    "FR": "France",
    "EU": "Union européenne"
  },
  "audit": {
    "title": "Audit structurel",
    "outputs": "Indicateurs clés retenus pour la gravité : {{outputs}}",
    "noOutputs": "Aucun indicateur clé trouvé : gravité selon ce que chaque constat alimente",
    "iterationOff": "calcul itératif désactivé",
    "hidden": "Masquées",
    "none": "Aucun constat ici.",
    "error": "Erreur",
    "construction": "Construction",
    "reaches": "atteint {{output}}",
    "feedsNothing": "n'alimente rien",
    "writeSheet": "Créer la feuille d'audit",
    "sheetWriting": "Écriture…",
    "sheetDone": "Feuille « Audit Findings » écrite",
    "sheetFailed": "L'écriture a échoué.",
    "fix": "Corriger",
    "fixMessage": "Corrige {{id}} ({{title}}) : applique la correction recommandée.",
    "fixRequested": "Correction demandée",
    "fixed": "Corrigé",
    "fixedCount_one": "{{count}} corrigé",
    "fixedCount_other": "{{count}} corrigés",
    "sheetUpdated": "Feuille « Audit Findings » mise à jour"
  },
  "drivers": {
    "title": "Ce qui fait varier ce chiffre",
    "counts": "{{business}} hypothèses métier · {{timing}} temps · {{pasted}} collées",
    "loop": "Le chiffre est dans une référence circulaire : les hypothèses de la boucle font partie de ses drivers.",
    "business": "Hypothèses métier, par concept",
    "none": "Aucune hypothèse métier en amont.",
    "inFormulas": "Nombres tapés dans les formules",
    "pasted": "Valeurs collées",
    "pastedNote": "Elles ne bougent qu'en recollant, pas quand les hypothèses changent.",
    "timing": "Temps ({{count}})",
    "timingRolled": "{{count}} hypothèses",
    "externals": "Venant d'autres classeurs : {{refs}}",
    "unresolved": "Non suivi (INDIRECT) : {{cells}} — des drivers peuvent manquer",
    "calculations": "Via {{count}} calculs : {{sheets}}",
    "select": "sélectionner",
    "share": "{{cells}} sur {{total}} cellules",
    "show": "Voir le détail : {{drivers}} drivers · {{calculations}} calculs",
    "tables": "Tables de correspondance",
    "tablesNote": "Lues seulement par VLOOKUP, INDEX, MATCH, SUMIFS… : la table fait varier le chiffre par l'entrée que la recherche y trouve.",
    "entries": "{{count}} entrées",
    "more": "+ {{count}} autres — demandez ce concept pour les lister",
    "dormant": "Sans effet en {{period}}",
    "dormantAny": "Sans effet sur cette période",
    "dormantNote": "Le chiffre les lit, mais elles ne le font pas varier sur cette période. Changez ce qui est indiqué dessous et elles comptent à nouveau.",
    "dormantCount": "{{count}} sans effet sur cette période"
  },
  "metrics": {
    "title": "Dates et indicateurs clés",
    "show": "Voir le détail : {{indicators}} indicateurs · {{dates}} dates clés",
    "family": {
      "dates": "Dates clés",
      "cover": "Couverture de la dette",
      "returns": "Rendements",
      "financing": "Financement"
    },
    "minAvg": "min {{min}} · moy {{avg}}",
    "zero": "0 sur toutes les périodes",
    "periods": "{{count}} périodes, {{first}} → {{last}}",
    "computed": "minimum et moyenne calculés par Sculpt : le fichier n'a pas de cellule MIN / MOYENNE",
    "also": "aussi en",
    "more": "+ {{count}} autres",
    "thresholds": "Seuils",
    "thresholdsNote": "Cibles, covenants et paramètres de dimensionnement — pas les indicateurs.",
    "selectors": "Scénario et sensibilité",
    "missing": "Introuvables dans le fichier : {{names}}"
  },
  "modelMap": {
    "title": "Comment le modèle est construit",
    "show": "Voir la carte : {{chains}} chaînes · {{families}} familles d'hypothèses",
    "counts": "{{concepts}} concepts · {{links}} liens entre eux",
    "chains": "Chaînes vers les sorties clés",
    "chainsNote": "Ce qui alimente chaque sortie, le plus lourd d'abord — drapeaux, calendriers et contrôles écartés.",
    "lines": "{{count}} lignes",
    "inputs": "hypothèses atteintes : {{families}}",
    "inventory": "Où se trouvent les hypothèses",
    "more": "+ {{count}} autres",
    "family": {
      "reserve": "Réserves",
      "valuation": "Valorisation",
      "statements": "États financiers",
      "debt": "Dette",
      "equity": "Fonds propres",
      "tax": "Fiscalité",
      "revenue": "Revenus",
      "opex": "Opex",
      "capex": "Capex",
      "quantity": "Quantités",
      "indexation": "Indexation",
      "asset": "Actif",
      "timing": "Temps",
      "other": "Autres"
    }
  },
  "terms": {
    "title": "Term sheet face au modèle",
    "show": "Voir tous les termes : {{gaps}} écarts · {{total}} termes",
    "status": {
      "gap": "Écarts",
      "ambiguous": "Plusieurs candidats",
      "to judge": "À juger",
      "not in the model": "Absents du modèle",
      "matches": "Conformes",
      "located": "Où le modèle les porte"
    },
    "document": "document",
    "gap": "écart {{gap}}",
    "computed": "calculé par le modèle",
    "instead": "À la place dans le modèle :",
    "notStated": "Non indiqués par le document : {{names}}",
    "milestones": "Jalons",
    "writeSheet": "Écrire les écarts dans une feuille",
    "sheetWriting": "Écriture…",
    "sheetDone": "Feuille « Term Sheet Gaps » écrite",
    "sheetFailed": "L'écriture a échoué."
  },
  "manual": {
    "title": "Écriture à la main",
    "sheets": "Seulement sur {{sheets}}",
    "undo": "Peut être annulée d’un bloc"
  }
}
